import classnames from 'classnames';
import {isNumber } from 'lodash';
import { __ } from '@wordpress/i18n';
import { DropdownMenu, ExternalLink, MenuGroup, MenuItem,TextControl, ToolbarButton, ToolbarGroup,} from '@wordpress/components';
import {MediaUpload,BlockControls} from '@wordpress/block-editor';
import { code,flipHorizontal as flipH,flipVertical as flipV, rotateRight,media as mediaIcon} from '@wordpress/icons';
import {parseUploadedMediaAndSetIcon} from './utils';
import { bolt as defaultIcon } from './icons/bolt';
import {VayuBlockLinkBlockControl} from '@vayu-blocks';
import {CopyPasteStyles} from '@vayu-blocks';

export const CustomBlockControls = ({
	icon, setAttributes, isContentOnlyMode, enableCustomIcons, isSVGUploadAllowed, 
	setInserterOpen, setCustomInserterOpen, attributes,
}) => {

	const customIconText = icon || attributes.iconName ? __( 'Add/edit custom icon', 'icon-block' ) : __( 'Add custom icon', 'icon-block' );

	const replaceText = icon || attributes.iconName ? __( 'Replace', 'vayu-blocks' ) : __( 'Add icon', 'vayu-blocks' );

    // const replaceDropdown = (
    //     <DropdownMenu
    //         icon=""
    //         popoverProps={ {
    //             className: 'outermost-icon-block__replace-popover is-alternate',
    //         } }
    //         text={ replaceText }
    //     >
    //         { ( { onClose } ) => (
    //             <>
    //                 <MenuGroup>
    //                     <MenuItem
    //                         onClick={ () => {
    //                             setInserterOpen( true );
    //                             onClose( true );
    //                         } }
    //                         icon={ defaultIcon }
    //                     >
    //                         { __( 'Browse Icon Library', 'icon-block' ) }
    //                     </MenuItem>

    //                     { isSVGUploadAllowed && (
    //                         <MediaUpload
    //                             onSelect={ ( media ) => {
    //                                 parseUploadedMediaAndSetIcon(
    //                                     media,
    //                                     attributes,
    //                                     setAttributes
    //                                 );
    //                                 onClose( true );
    //                             } }
    //                             allowedTypes={ [ 'image/svg+xml' ] }
    //                             render={ ( { open } ) => (
    //                                 <MenuItem
    //                                     onClick={ open }
    //                                     icon={ mediaIcon }
    //                                 >
    //                                     { __(
    //                                         'Open Media Library',
    //                                         'icon-block'
    //                                     ) }
    //                                 </MenuItem>
    //                             ) }
    //                         />
    //                     ) }

    //                     { enableCustomIcons && (
    //                         <MenuItem
    //                             onClick={ () => {
    //                                 setCustomInserterOpen( true );
    //                                 onClose( true );
    //                             } }
    //                             icon={ code }
    //                         >
    //                             { customIconText }
    //                         </MenuItem>
    //                     ) }
    //                 </MenuGroup>
                    
    //             </>
    //         ) }
    //     </DropdownMenu>
    // );

    function setRotate( value ) {
		const currentValue = isNumber( value ) ? value : 0;
		let newValue = currentValue + 90;

		if ( currentValue === 270 ) {
			newValue = 0;
		}

		setAttributes( { rotate: newValue } );
	}

	return (
		<>

				{(icon || attributes.iconName) && (
					<BlockControls group="block">
						<ToolbarGroup
							className={classnames('components-toolbar-group', {
								'wp-block-outermost-icon-block__toolbar': !isContentOnlyMode,
							})}
						>
							{!isContentOnlyMode && (
								<>
									<ToolbarButton
										className={`outermost-icon-block__rotate-button-${attributes.rotate}`}
										icon={rotateRight}
										label={__('Rotate', 'vayu-blocks')}
										onClick={() => setRotate(attributes.rotate)}
										isPressed={attributes.rotate}
									/>
									<ToolbarButton
										icon={flipH}
										label={__('Flip Horizontal', 'vayu-blocks')}
										onClick={() =>
											setAttributes({
												flipHorizontal: !attributes.flipHorizontal,
											})
										}
										isPressed={attributes.flipHorizontal}
									/>
									<ToolbarButton
										icon={flipV}
										label={__('Flip Vertical', 'vayu-blocks')}
										onClick={() =>
											setAttributes({
												flipVertical: !attributes.flipVertical,
											})
										}
										isPressed={attributes.flipVertical}
									/>
								</>
							)}
						</ToolbarGroup>
					</BlockControls>
				)}

				{/* <BlockControls group={isContentOnlyMode ? 'inline' : 'other'}>
					<ToolbarGroup className="components-toolbar-group">
						<>
							{enableCustomIcons || isSVGUploadAllowed ? (
								replaceDropdown
							) : (
								<ToolbarButton onClick={() => setInserterOpen(true)}>
									{replaceText}
								</ToolbarButton>
							)}
						</>
					</ToolbarGroup>
				</BlockControls> */}

				{isContentOnlyMode && (icon || iconName) && (
					<BlockControls group="other">
						<ToolbarGroup className="components-toolbar-group">
							<DropdownMenu
								icon=""
								popoverProps={{
									className: 'outermost-icon-block__replace-popover is-alternate',
								}}
								text={__('Label', 'vayu-blocks')}
							>
								{() => (
									<TextControl
										className="wp-block-outermost-icon-block__toolbar_content"
										label={__('Label', 'vayu-blocks')}
										value={attributes.label || ''}
										onChange={(value) =>
											setAttributes({ label: value })
										}
										help={__('Briefly describe the icon to help screen reader users.', 'vayu-blocks')}
										__nextHasNoMarginBottom={true}
									/>
								)}
							</DropdownMenu>
							<DropdownMenu
								icon=""
								popoverProps={{
									className: 'outermost-icon-block__replace-popover is-alternate',
								}}
								text={__('Title', 'vayu-blocks')}
							>
								{() => (
									<TextControl
										className="wp-block-outermost-icon-block__toolbar_content"
										label={__('Title', 'vayu-blocks')}
										value={attributes.title || ''}
										onChange={(value) =>
											setAttributes({ title: value })
										}
										help={
											<>
												{__('Describe the role of this icon on the page. ', 'vayu-blocks')}
												<ExternalLink href="https://www.w3.org/TR/html52/dom.html#the-title-attribute">
													{__('Note: many devices and browsers do not display this text', 'vayu-blocks')}
												</ExternalLink>
											</>
										}
										__nextHasNoMarginBottom={true}
									/>
								)}
							</DropdownMenu>
						</ToolbarGroup>

					</BlockControls>
				)}

				<VayuBlockLinkBlockControl
					value={attributes.link}
					attributeKey="link"
					onChange={(key, value) => setAttributes({ [key]: value })}
				/>

				<BlockControls>
					<CopyPasteStyles attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/icon'} exclude={['icon', 'iconName', 'printedIcon', 'mediaIcon']}/>
				</BlockControls>
		</>
	);
};
